import React, { Fragment } from 'react';
import GroupBg from '../assets/main/bg-group.jpg';
import Header from '../components/Header';
import DeputyGroup from '../components/DeputyGroup';
import { useParams } from 'react-router-dom';
import { getDeputyTitleFromRouteId, getGroupDeputy } from '../utils/deputy';
import { useTranslation } from 'react-i18next';
import { getBackgroundImage } from '../utils/organization';

export default function GroupPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  const deputies = getGroupDeputy(id);

  return (
    <div
      className="min-h-screen w-full bg-[#002D4B] flex flex-col justify-between text-white bg-cover bg-no-repeat relative overflow-x-hidden overflow-y-auto"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(0, 45, 75, 0.88) 0%, rgba(0, 30, 49, 0.95) 100%), url(${GroupBg})`,
      }}
    >
      <div className="w-full max-w-[1500px] mx-auto px-6 md:px-12 min-h-screen flex flex-col justify-between py-6 relative z-10">
        <Header />

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 my-auto w-full flex-1 items-center py-6">
          {deputies.map((deputy, idx) => (
            <Fragment key={deputy}>
              <DeputyGroup
                text={getDeputyTitleFromRouteId(deputy, t)}
                route={`/${deputy}`}
                background={getBackgroundImage(deputy)}
                index={idx}
              />
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
